import {axios} from "../helpers"

export const postTrackingQueryService = (form) => {

    return axios.post(`${process.env.REACT_APP_TRACKING_API_URL}api/v1/tracking-query`, form)

}
